import { m } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// hooks
import { useMockedUser } from 'src/hooks/use-mocked-user';
// auth
// components
import { varHover } from 'src/components/animate';
import { useSnackbar } from 'src/components/snackbar';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { useDispatch } from 'react-redux';
import { useLogoutMutation } from 'src/store/Reducer/auth';
import { clear, setUser } from 'src/store/slices/userSlice';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useBoolean } from 'src/hooks/use-boolean';
import { LoadingButton } from '@mui/lab';
import { useLocales } from 'src/locales';

// ----------------------------------------------------------------------

// const OPTIONS = [
//   {
//     label: 'Home',
//     // linkTo: paths.orangizerDashboard.root,
//     linkTo:"/"
//   },
//   {
//     label: 'Profile',
//     linkTo: paths.orangizerDashboard.user.profile,
//   },
// ];
// const OPTIONS2 = [
//   {
//     label: 'Home',
//     // linkTo: paths.superAdminDashboard.root,
//     linkTo: "/"
//   },
//   {
//     label: 'Settings',
//     linkTo: paths.superAdminDashboard.user.account,
//   },

// ]
// const OPTIONS3 = [
//   {
//     label: 'Home',
//     // linkTo: paths.dashboard.home,
//     linkTo: "/"
//   },
//   {
//     label: 'Profile',
//     linkTo: paths.dashboard.user.profile,
//   }
// ]

// ----------------------------------------------------------------------

export default function AccountPopover() {

  const router = useRouter();
  const { user } = useMockedUser();
  const dispatch = useDispatch();
  const { onChangeLang, t } = useLocales();

  const OPTIONS = [
    {
      label: t("home.home"),
      linkTo: "/",
    },
    {
      label: t("home.profile"),
      linkTo: paths.orangizerDashboard.user.profile,
    },
  ];

  const OPTIONS2 = [
    {
      label: t("home.home"),
      linkTo: "/",
    },
    {
      label: t("home.settings"),
      linkTo: paths.superAdminDashboard.user.account,
    },
  ];

  const OPTIONS3 = [
    {
      label: t("home.home"),
      linkTo: "/",
    },
    {
      label: t("home.profile"),
      linkTo: paths.dashboard.user.profile,
    },
  ];


  const isAdmin = user?.userType === 'super-admin';

  const [logout, { isLoading }] = useLogoutMutation();

  const { enqueueSnackbar } = useSnackbar();

  const popover = usePopover();

  const deleteModal = useBoolean();

  const handleLogout = async () => {
    try {
      const response = await logout({ deviceId: '123456' });

      if (!response?.error) {
        enqueueSnackbar(t('msg.logout_success'), { variant: 'success' });

        dispatch(clear())

        localStorage.removeItem("persist:root");

        popover.onClose();

        router.push("/");
      }
    } catch (error) {
      console.error(error);
      enqueueSnackbar(t('msg.logout_error'), { variant: 'error' });
    }
  };


  const handleClickItem = (path) => {
    popover.onClose();
    router.push(path);
  };

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={user?.profileIcon}
          alt={user?.displayName}
          sx={{
            width: 36,
            height: 36,
            border: (theme) => `solid 2px ${theme.palette.background.default}`,
          }}
        >
          {user?.firstName?.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.firstName}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        {<Divider sx={{ borderStyle: 'dashed' }} />}

        <Stack sx={{ p: 1 }}>
          {user?.userType === "user" && OPTIONS3.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
          {user?.userType === "organizer" && OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
          {user?.userType === "super-admin" && OPTIONS2.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={deleteModal.onTrue}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          {t("home.logout")}
        </MenuItem>
      </CustomPopover>

      <ConfirmDialog
        maxWidth="xs"
        fullWidth
        title={t("home.logout")}
        content={t("home.logout_confirmation")}
        open={deleteModal.value}
        onClose={deleteModal.onFalse}
        action={
          <LoadingButton variant="contained" onClick={handleLogout} color="error" loading={isLoading}>
            {t("home.logout")}</LoadingButton>
        }
      />
    </>
  );
}
